export namespace Regex {
  export namespace Dates {
    export const ISO8601 = /^[12]\d{3}-[01][0-9]-[0-3][0-9]$/;
    export const UK = /^[0-3][0-9]\/[01][0-9]\/[12]\d{3}$/;
  }

  export const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  export const PHONE_NUMBER = {
    CA: /^[0-9+ ()-]+$/,
    Default: /^[0-9+ ]+$/,
  };

  export const URLS = {
    SUBDOMAIN_PASTE: /^[a-zA-Z0-9]+(?:-[a-z0-9]+)*$/,
    SUBDOMAIN_KEYDOWN: /[a-zA-Z0-9-]/,
    SITE_ALIAS: /^[a-z0-9-]+$/i,
    HREF: /^(https?):\/\/[^\s$.?#].[^\s]*$/gm,
  };

  export const PRICING = /^\d+(\.\d{1,2})?$/;
  export const PERCENTAGES_DECIMAL = /^(\d{0,2}(\.\d{1,2})?|100(\.00?)?)$/;
  export const BASE_64_IMAGES = /^data:image\/(png|jpg|jpeg|gif);base64,/;
}
